// ============================================================================
// todo-client-mod -- Mod 定义
//
// 提供：
// 1. 用户中心 Slot — "我的待办"管理面板（写操作，需要登录）
// 2. 公开页面    — /todo 待办列表 + /todo/:id 待办详情（给访客浏览）
// 3. TodoApiClient  — HTTP API 客户端（支持 DI 注入 IFetchService）
// ============================================================================
import { USER_CENTER_SLOTS_INTERFACE_TAG } from '@hvsin/user-center-contracts';
import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG } from '@hvsin/ui-registry-contracts';
import { FETCH_SERVICE_INTERFACE_TAG } from '@hvsin/fetch-contracts';
import { TodoRegistrar } from './todo-registrar.js';
import { TodoApiClient } from './todo-api-client.js';
export const todoClientMod = {
    name: 'todo-client',
    serviceDefs: [
        {
            serviceTag: 'todoRegistrar',
            serviceImpl: TodoRegistrar,
            dependencies: [
                USER_CENTER_SLOTS_INTERFACE_TAG,
                PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
                FETCH_SERVICE_INTERFACE_TAG,
            ],
        },
        {
            serviceTag: 'todoApiClient',
            serviceImpl: TodoApiClient,
            dependencies: [FETCH_SERVICE_INTERFACE_TAG],
        },
    ],
};
//# sourceMappingURL=mod.js.map